import { Component, Inject, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AddNewDigitalQuestionsVM, AnswerList, AnswerListVM, DigitalFormQuestionTypesVM, Form, FormCategory, ModalFormCatData, ModalFormData, MultipleChoiceAnswer, SaveAnswerForDigitalFormQuestionVM, StateVM } from '../../../perform-induction/perform-induction';
import { SafetyInductionService } from '../../../services/safety-induction.service';
import { FileReaderEvent } from '../../../setup-implement/setup-implement.component';
import { NewInspectionService } from '../../../../inspection/services/new-inspection.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
export interface DialogData {
  QuestionTypes: DigitalFormQuestionTypesVM[],
  QuestionId: number,
  CatId: number,
  FormId: number,
  AddQuestion: boolean,
  Title: string,
  Description: string,
  QuestionTypeId: number,
  isAdditonalObs:boolean;
}
@Component({
  selector: 'app-dialog-setup-answers',
  templateUrl: './dialog-setup-answers.component.html',
  styleUrls: ['./dialog-setup-answers.component.scss']
})
export class DialogSetupAnswersComponent implements OnInit {

  constructor(
    private _sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<DialogSetupAnswersComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private _inductionService: SafetyInductionService,
    private _inspectionService: NewInspectionService,
  ) { }


  AddQuestion: boolean = false;
  Description: string = "";
  Title: string = "";
  QuestionType: number = -1;
  QuestionTypeTitle: string = "";
  Answer: string = ""
  AnswerOptionOne:string="";
  AnswerOptionTwo:string="";
  AnswerList:AnswerListVM[]=[]
  MultipleChoiceAnswerList:MultipleChoiceAnswer[]=[];
  MultipleSelectionAnswerList:MultipleChoiceAnswer[]=[];

  isAdditonalObs:boolean=false;
  ngOnInit() {


    let QType = this.data.QuestionTypes.find(f => f.Id == this.data.QuestionTypeId)

    this.Title = this.data.Title
    this.Description = this.data.Description
    this.QuestionType = QType.Id
    this.QuestionTypeTitle = QType.Title;
    this.isAdditonalObs=this.data.isAdditonalObs;

    if(this.data.QuestionTypeId > -1 && this.isAdditonalObs==false){
      console.log("this.data",this.data)
      this._inductionService.GetAnswerListForDigitalFormQuestionId(this.data.QuestionId).subscribe(res=>{
        console.log("GetAnswerListForDigitalFormQuestionId",res)
        if(this.data.QuestionTypeId == 1){
          if(res.length >0){
            this.AnswerList = res
            this.AnswerOptionOne = res[0].answer
            this.AnswerOptionTwo = res[1].answer
  
          }
        }else if(this.data.QuestionTypeId == 2){
          res.map((m,i)=>{
            let options = new MultipleChoiceAnswer();
            options.name = m.answer;
            options.select = m.correct;
            options.key = i;

            this.MultipleChoiceAnswerList.push(options)
          })
          this.LoadMultipleChoiceAnswer();
        }else if(this.data.QuestionTypeId == 3){
          res.map((m,i)=>{
            let options = new MultipleChoiceAnswer();
            options.name = m.answer;
            options.select = m.correct;
            options.key = i;

            this.MultipleSelectionAnswerList.push(options)
          })
          this.LoadMultipleSelectionAnswers();
        }

      });
    }


    if(this.data.QuestionTypeId > -1 && this.isAdditonalObs==true){
      console.log("this.data",this.data)
      this._inspectionService.GetAnswerListForAdditonalObservationId(this.data.QuestionId).subscribe(res=>{
        console.log("GetAnswerListForAdditonalObservationId",res);
        if(this.data.QuestionTypeId == 1){
          if(res.length >0){
            this.AnswerList = res
            this.AnswerOptionOne = res[0].answer
            this.AnswerOptionTwo = res[1].answer
  
          }
        }else if(this.data.QuestionTypeId == 2){
          res.map((m,i)=>{
            let options = new MultipleChoiceAnswer();
            options.name = m.answer;
            options.select = m.correct;
            options.key = i;

            this.MultipleChoiceAnswerList.push(options)
          })
          this.LoadMultipleChoiceAnswer();
        }else if(this.data.QuestionTypeId == 3){
          res.map((m,i)=>{
            let options = new MultipleChoiceAnswer();
            options.name = m.answer;
            options.select = m.correct;
            options.key = i;

            this.MultipleSelectionAnswerList.push(options)
          })
          this.LoadMultipleSelectionAnswers();
        }

      });
    }
  }
  onClickAddAnswerMultipleSel(){
    let options = new MultipleChoiceAnswer();
            options.name = this.Answer;
            //options.select = false;
            //options.key = i;

            this.MultipleSelectionAnswerList.push(options)
            this.Answer = ""
  }
  onClickAddAnswer(){
    let options = new MultipleChoiceAnswer();
            options.name = this.Answer;
            //options.select = false;
            //options.key = i;

            this.MultipleChoiceAnswerList.push(options)
            this.Answer = ""
  }

  OnclickDeleteOption(answer){
    let arr = this.MultipleChoiceAnswerList.filter(f=>f.name != answer.name)
    this.MultipleChoiceAnswerList=arr

  }

  OnclickDeleteOptionMultipleSel(answer){
    let arr = this.MultipleSelectionAnswerList.filter(f=>f.name != answer.name)
    this.MultipleSelectionAnswerList=arr

  }

  LoadMultipleChoiceAnswer(){

  }

  LoadMultipleSelectionAnswers(){
    
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSubmitClick(): void {
    if(this.data.QuestionTypeId == 1){

      
      let ArrAns=[];
      let objAns1=new AnswerList();
      objAns1.answer = this.AnswerOptionOne
      ArrAns.push(objAns1)
      let objAns2=new AnswerList();
      objAns2.answer = this.AnswerOptionTwo
      ArrAns.push(objAns2)


      let req = new SaveAnswerForDigitalFormQuestionVM();
      req.AnswerList = ArrAns
      req.QId = this.data.QuestionId
      req.QType = this.QuestionType

      if(this.isAdditonalObs==false){
        this._inductionService.SaveAnswerForDigitalFormQuestion(req).subscribe(res => {
          console.log("SaveAnswerForDigitalFormQuestion",res)
          if (res) {
  
            this.dialogRef.close(true);
          }
        })
      }else{
        this.SaveAddiotnalObservationRefernceAnswer(req)

      }
      
    }else if(this.data.QuestionTypeId == 2){
      let ArrAns=[];
      this.MultipleChoiceAnswerList.map(m=>{
        let ans = new AnswerList();
        ans.answer = m.name
        ArrAns.push(ans)
      })

      let req = new SaveAnswerForDigitalFormQuestionVM();
      req.AnswerList = ArrAns
      req.QId = this.data.QuestionId
      req.QType = this.QuestionType

if(this.isAdditonalObs==false){
  this._inductionService.SaveAnswerForDigitalFormQuestion(req).subscribe(res => {
    this.dialogRef.close(true);
})
}else{
  this.SaveAddiotnalObservationRefernceAnswer(req)

}
      
     
    }else if(this.data.QuestionTypeId == 3){
      let ArrAns=[];
      this.MultipleSelectionAnswerList.map(m=>{
        let ans = new AnswerList();
        ans.answer = m.name
        console.log("ans",ans)
        console.log("m",m)
        
        console.log("ArrAns",ArrAns)

        ArrAns.push(ans)
      })

      let req = new SaveAnswerForDigitalFormQuestionVM();
      req.AnswerList = ArrAns
      req.QId = this.data.QuestionId
      req.QType = this.QuestionType

      if(this.isAdditonalObs==false){
        this._inductionService.SaveAnswerForDigitalFormQuestion(req).subscribe(res => {
          this.dialogRef.close(true);
      })
      }else{
        this.SaveAddiotnalObservationRefernceAnswer(req) 
      }
      

    }
  


  }

  SaveAddiotnalObservationRefernceAnswer(req:SaveAnswerForDigitalFormQuestionVM){
    this._inductionService.SaveAnswerForAdditonalObservation(req).subscribe(res=>{
      this.dialogRef.close(true);
    })
  }


}
